import vanityUrlRedirects from '../../../data/vanityUrlRedirects.json';

export default function getVanitySlug(guideId) {
  return vanityUrlRedirects.guideIdsToPathnames[guideId];
}
